import { useContext } from "react";

import { ProfilesPageContext } from "./profiles_page_context";

export const useProfilesPageContext = () => {
  const context = useContext(ProfilesPageContext);

  if (!context) {
    throw new Error("useProfilesPageContext must be used within a ProfilesPageContextProvider");
  }

  return context;
};
